const ApartmentNotAvailable = () => {
    return(
        <div className="apartment-not-available">
            <h4>This apartment is no longer available</h4>
        </div>
    )
}
export default ApartmentNotAvailable;